import { GameLeaderboardContentProps } from './props';
import GameLeaderboardTable from './Table';
import styles from './styles.module.scss';
import { memo } from 'react';

function GameLeaderboardContent({
  isLoading,
  scoreboard,
  fetchNextPage,
  isFetchingNextPage,
  hasNextPage,
  shouldShowResult,
  shouldShowReducedInfo,
  smallerHeight,
}: GameLeaderboardContentProps) {
  return (
    <div className={styles.container}>
      <GameLeaderboardTable
        scoreboard={scoreboard}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        shouldShowResult={shouldShowResult}
        shouldShowReducedInfo={shouldShowReducedInfo}
        smallerHeight={smallerHeight}
      />
    </div>
  );
}

export default memo(GameLeaderboardContent);
